import { productView } from '../../../features/commerce/product/product-actions.js';
/**
 * Creates an `ProductView` controller instance.
 *
 * @param engine - The headless commerce engine.
 * @returns A `ProductView` controller instance.
 *
 * @group Buildable controllers
 * @category ProductView
 */
export function buildProductView(engine) {
    return {
        view: (product) => {
            engine.dispatch(productView(product));
        },
    };
}
